import { SingleLanguageCopyType } from '../../../assets/copy';

let events = {
  thanksAcademy: {
    key: 'thanksAcademy',
    recurring: true,
    getTitle: (copy: SingleLanguageCopyType) => copy.teachersPet,
    getDescription: (copy: SingleLanguageCopyType) =>
      copy.aWinnerThanksTheAcademyOneOrMoreTimesInTheirAcceptanceSpeech,
  },
  thanksMom: {
    key: 'thanksMom',
    recurring: true,
    getTitle: (copy: SingleLanguageCopyType) => copy.mooooom,
    getDescription: (copy: SingleLanguageCopyType) =>
      copy.aWinnerThanksTheirMotherOneOrMoreTimesInTheirAcceptanceSpeech,
  },
  thanksGod: {
    key: 'thanksGod',
    recurring: true,
    getTitle: (copy: SingleLanguageCopyType) => copy.divineIntervention,
    getDescription: (copy: SingleLanguageCopyType) =>
      copy.aWinnerThanksADivinePowerOneOrMoreTimesInTheirAcceptanceSpeech,
  },
  wrongWinner: {
    key: 'wrongWinner',
    recurring: false,
    getTitle: (copy: SingleLanguageCopyType) => copy.laLaLand,
    getDescription: (copy: SingleLanguageCopyType) =>
      copy.theWrongWinnerIsAnnouncedInAnyCategory,
  },
} as const;

export default events;
